export default "ui-grid{display:block}ui-grid.-singleview ui-griditem{text-align:center}\n";